import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const PLUGINS_API_PATH = '/rest/plugins';
export const getPluginSkillsQueryKeyPrefix = (pluginId) => QueryClientHelper.makeQueryKey(PLUGINS_API_PATH, pluginId, 'skills');
export const getPluginDiscoverKey = () => QueryClientHelper.makeQueryKey('/rest/plugins/discover');
//# sourceMappingURL=pluginKeys.js.map